import React from "react";
import { motion } from "framer-motion";
import { Mail, PhoneCall, Globe } from "lucide-react";

const contactItems = [
  {
    icon: <Mail className="text-primary w-6 h-6" />,
    label: "Email",
    value: "invest@booksatdoorsteps.com",
    href: "mailto:invest@booksatdoorsteps.com",
  },
  {
    icon: <PhoneCall className="text-primary w-6 h-6" />,
    label: "Call / WhatsApp",
    value: "+91-9860133100",
    href: "tel:+919860133100",
  },
  {
    icon: <Globe className="text-primary w-6 h-6" />,
    label: "Website",
    value: "www.booksatdoorsteps.com",
    href: "https://www.booksatdoorsteps.com",
  },
];

const FutureTogetherSection = () => {
  return (
    <section className="bg-gradient-to-b from-indigo-50 to-white py-20 px-6 md:px-10">
      <div className="max-w-5xl mx-auto text-center">
        <motion.h2
          className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
           Let’s Build the Future Together
        </motion.h2>

        <p className="text-lg text-gray-600 mb-10 max-w-2xl mx-auto">
          Together, let’s turn readers into leaders — one doorstep at a time.
        </p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="bg-white border border-gray-200 rounded-2xl shadow-2xl p-8 md:p-10 mx-auto w-full max-w-xl space-y-6 text-left"
        >
          {contactItems.map((item, index) => (
            <div key={index} className="flex items-start gap-4">
              <div className="pt-1">{item.icon}</div>
              <div>
                <p className="text-sm font-medium text-gray-800">{item.label}</p>
                <a
                  href={item.href}
                  className="text-primary font-semibold hover:underline break-words"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {item.value}
                </a>
              </div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default FutureTogetherSection;
